import React, { useState, useEffect } from "react";
import axios from "axios";
import "./SignUpFrom2.css";
import { baseURLs } from "../constants";

const Check = () => {
  const [formData, setFormData] = useState({ firstname: "", lastname: "" });
  const [memberId, setMemberId] = useState(null);
  const [error, setError] = useState(null);
  const [updateKey, setUpdateKey] = useState(0); 

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value.replace(/[^a-zA-Zก-๙\s]/g, ""), 
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.firstname || !formData.lastname) {
    setError("กรุณากรอกชื่อและนามสกุล");
    return;
  }

  setError(null);
  setMemberId(null);
 

  try {
    const response = await axios.get(
      `${baseURLs.api}/Home/CheckMemberId`,
      {
        params: {
          firstname: formData.firstname,
          lastname: formData.lastname,
        },
      }
    );

    

    // 🔍 ตรวจสอบว่าข้อมูลอยู่ตรงไหน
    const memberIdFromAPI = response.data?.memberId || response.data?.data?.memberId;

    if (memberIdFromAPI) {
      setMemberId(memberIdFromAPI);
    } else {
      setError("ไม่พบเลขที่สมาชิกสำหรับชื่อและนามสกุลนี้");
    }
  } catch (err) {
    
    setError("เกิดข้อผิดพลาดในการเชื่อมต่อกับเซิร์ฟเวอร์");
  }
};

  

  
  useEffect(() => {
    
  }, [memberId]);

  return (
    <div
      className="container-fluid signup-page"
      style={{
        backgroundImage: "url('/RegisterAssoc/tower.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div className="card shadow p-4" style={{ maxWidth: "500px", width: "100%" }}>
        <h2 className="text-center mb-4">ตรวจสอบเลขที่สมาชิก</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="firstname" className="form-label">ชื่อ</label>
            <input
              type="text"
              className="form-control"
              id="firstname"
              placeholder="กรอกชื่อของคุณ"
              value={formData.firstname}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="lastname" className="form-label">นามสกุล</label>
            <input
              type="text"
              className="form-control"
              id="lastname"
              placeholder="กรอกนามสกุลของคุณ"
              value={formData.lastname}
              onChange={handleInputChange}
              required
            />
          </div>
          {error && <div className="alert alert-danger">{error}</div>}
          <div className="d-grid">
            <button type="submit" className="btn btn-primary">ตรวจสอบ</button>
          </div>
        </form>
        {memberId && (
  <div className="mt-4 alert alert-success text-center">
      เลขที่สมาชิกของคุณคือ:  <br /><strong>{memberId}</strong>
  </div>
)}

        
      </div>
    </div>
  );
};

export default Check;
